/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadScreenerLeadInfoRace
 */
export interface LeadScreenerLeadInfoRace {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name?: string;
}

/**
 * Check if a given object implements the LeadScreenerLeadInfoRace interface.
 */
export function instanceOfLeadScreenerLeadInfoRace(value: object): value is LeadScreenerLeadInfoRace {
    return true;
}

export function LeadScreenerLeadInfoRaceFromJSON(json: any): LeadScreenerLeadInfoRace {
    return LeadScreenerLeadInfoRaceFromJSONTyped(json, false);
}

export function LeadScreenerLeadInfoRaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadScreenerLeadInfoRace {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function LeadScreenerLeadInfoRaceToJSON(json: any): LeadScreenerLeadInfoRace {
    return LeadScreenerLeadInfoRaceToJSONTyped(json, false);
}

export function LeadScreenerLeadInfoRaceToJSONTyped(value?: LeadScreenerLeadInfoRace | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

